module.exports = __webpack_public_path__ + "img/home_icon_appxiazai@2x.3629306e.png";